/**
 * Запрет прокрутки страницы под открытой шторкой.
 *
 * Простого `overflow: hidden` здесь мало: во встроенном браузере iOS
 * страница всё равно тянется за палец. Надёжно работает только перевод
 * body в position: fixed — тогда прокручивать нечего.
 *
 * Отсюда же необходимость запоминать положение: выведенный из потока body
 * теряет прокрутку, и без возврата список после закрытия шторки оказался
 * бы в самом верху.
 */
import { useEffect } from 'react';

export function useScrollLock(locked: boolean): void {
  useEffect(() => {
    if (!locked) {
      return;
    }

    const { body } = document;
    const offset = window.scrollY;
    const saved = {
      position: body.style.position,
      top: body.style.top,
      left: body.style.left,
      right: body.style.right,
      width: body.style.width,
    };

    body.style.position = 'fixed';
    body.style.top = `-${offset}px`;
    body.style.left = '0';
    body.style.right = '0';
    body.style.width = '100%';

    return () => {
      body.style.position = saved.position;
      body.style.top = saved.top;
      body.style.left = saved.left;
      body.style.right = saved.right;
      body.style.width = saved.width;
      // Возврат делается без плавности: анимированная прокрутка здесь
      // выглядит как самопроизвольное движение списка после закрытия.
      window.scrollTo(0, offset);
    };
  }, [locked]);
}
